<template>
  <v-container fluid class="px-5 pt-6 flex-col-start-start gap-6">
    <div class="px-6 w-100">
      <BalanceStepper :items="stepperItems" :currentStep="step" />
    </div>
    <v-expansion-panels mandatory accordion :value="step" class="mt-10">
      <v-expansion-panel
        v-for="(sections, group, index) in fieldsGroups"
        :key="group"
        :readonly="index > step"
      >
        <v-expansion-panel-header disable-icon-rotate>
          {{ $t(group) }}
          <template v-slot:actions>
            <v-icon
              :color="
                step > index ? 'success' : step === index ? 'mainBlue' : 'error'
              "
            >
              {{
                step > index
                  ? "mdi-check"
                  : step === index
                  ? "mdi-pencil"
                  : stepWithError === index
                  ? "mdi-alert-circle"
                  : ""
              }}
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content style="direction: ltr !important">
          <BalanceSections
            :sections="sections"
            :group="group"
            :disablePrev="step === 0"
            :groupData="getGroupData(group)"
            :enableSubmit="step + 1 === stepperItems.length"
            :enableActions="step === index"
            :submitLoading="loading"
            @next="handleNextStep"
            @back="handlePrevStep"
            @submit="handleSubmit"
            @enableError="stepWithError = step"
            @disableError="stepWithError = null"
            @valueChange="(data) => updateValue(data, group, index)"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <BalanceResult
      :show="showResult"
      :req-air="latestReqAir"
      @close="showResult = false"
    />
  </v-container>
</template>

<script>
import { BALANCE_FIELD_GROUPS, GROUP_FIELDS_DEFAULT_VALUE } from "./data";
import BalanceStepper from "./fragments/BalanceStepper.vue";
import BalanceSections from "./fragments/BalanceSections.vue";
import BalanceResult from "./fragments/BalanceResults.vue";
import { ADD_BALANCE } from "@/core/services/store/modules/balance/balance.module";
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";

export default {
  name: "Balance",

  data() {
    return {
      stepWithError: null,
      step: 0,
      fieldsGroups: BALANCE_FIELD_GROUPS,
      balanceData: GROUP_FIELDS_DEFAULT_VALUE,
      loading: false,
      showResult: false,
      latestReqAir: 0,
    };
  },

  computed: {
    stepperItems() {
      return Object.keys(BALANCE_FIELD_GROUPS);
    },
  },

  methods: {
    handleNextStep() {
      if (this.step === this.stepWithError) this.stepWithError = null;
      if (this.step < this.stepperItems.length) this.step++;
    },
    handlePrevStep() {
      this.step--;
    },
    updateValue({ value, key }, group, stepNumber) {
      this.step = stepNumber;
      const targetGroup = key.startsWith("cdbus_") ? "natural_gas" : group;
      this.balanceData = {
        ...this.balanceData,
        [targetGroup]: {
          ...this.balanceData[targetGroup],
          [key]: Number(value),
        },
      };
    },
    async handleSubmit() {
      this.loading = true;
      await this.$store
        .dispatch(ADD_BALANCE, this.balanceData)
        .then((res) => {
          this.latestReqAir = Number(res?.data?.data?.output?.reqAir) || 0;
          this.showResult = true;
          this.step = 0;
          this.balanceData = GROUP_FIELDS_DEFAULT_VALUE;
        })
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        });
      this.loading = false;
    },
    getGroupData(group) {
      if (group === "process_flows") {
        return { ...this.balanceData[group], ...this.balanceData.natural_gas };
      }
      return this.balanceData[group];
    },
  },

  components: {
    BalanceStepper,
    BalanceSections,
    BalanceResult,
  },
};
</script>
